import { render, staticRenderFns } from "./UserScore.vue?vue&type=template&id=feb695ac&scoped=true"
import script from "./UserScore.vue?vue&type=script&lang=js"
export * from "./UserScore.vue?vue&type=script&lang=js"
import style0 from "./UserScore.vue?vue&type=style&index=0&id=feb695ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb695ac",
  null
  
)

export default component.exports